import { data } from '@amazon/vinyl-observable'
import { globalData } from '@amzn/amp-playback'

export const nerdStatsVisible = globalData(() => data(false))

export function toggleNerdStats() {
    nerdStatsVisible.value = !nerdStatsVisible.value
}
